const PUBLIC = process.env.PUBLIC_URL || '';

/** Пути в `public/igra` (латиница — надёжные URL на CDN). */
export function igraPublicAssetUrl(filename) {
  return `${PUBLIC}/igra/${filename}`;
}

export const IGRA_ROOM_ASSETS = {
  bg: igraPublicAssetUrl('zadnijfon-game.png.svg'),
  header: igraPublicAssetUrl('header-game-png.svg'),
  back: igraPublicAssetUrl('button-back-to-lobby.png.svg'),
};
